import {
    ContactOrganizerButton,
    ContactOrganizerProps,
} from '@eventbrite/contact-organizer-button';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { useEventBasicInformationContext } from '../../contexts';
import { useOrganizerBasicInfo } from '../../contexts/OrganizerContext';
import './ContactOrganizerButtonListings.scss';

const NEW_HIERARCHY_CUSTOM_CONTACT_TEXT =
    gettext('Contact organizer').toString();
// Custom text to be displayed instead of 'Contact the organizer' to follow design spec for Listings that Convert initiative

export const ContactOrganizerButtonListings: React.FC<
    Pick<
        ContactOrganizerProps,
        | 'captchaKey'
        | 'isVisible'
        | 'isAuthenticated'
        | 'gaCategory'
        | 'domNodeId'
    > & {
        className?: string;
    }
> = (props) => {
    const { id: orgId, name: orgName } = useOrganizerBasicInfo();
    const { name: eventName, id: eventId } = useEventBasicInformationContext();
    return (
        <ContactOrganizerButton
            {...props}
            className={`contact-organizer-listing-page ${
                props.className || ''
            }`}
            organizerId={orgId}
            organizerName={orgName}
            eventName={eventName}
            eventId={eventId}
            customText={orgName ? undefined : NEW_HIERARCHY_CUSTOM_CONTACT_TEXT}
        />
    );
};
